module.exports = __webpack_public_path__ + "img/img_throw_2@2x_v3.200ea43a.png";